module.exports = __webpack_public_path__ + "img/Octocat-riddlocat.3ea2bcfd.png";